import { 
    Color,
    HeightReference,
    Cartesian2,
    Cartesian3,
    PolylineVolumeGraphics,
    Cartographic,
    JulianDate,
    Transforms,
    Math as CesiumMath,
    HeadingPitchRoll,
    TranslationRotationScale,
    PropertyBag,
    Quaternion,
    defined,
    CesiumTerrainProvider
    } from "cesium";
import { Tileset, TMS, GeoJSON, Terrain} from './layer-types.js'

export const arcgisBaseURL = "https://arc.csds.om:6443";
//export const arcgisBaseURL = "https://192.168.70.39:6443";
export const arcgisMap = "SurSohar";

// export const applicationUrl = "https://app.csds.om/madayn";
export const applicationUrl = ".";

const defaultPoleHeight = 10.0;
// const defaultPoleScale = 0.00089;

function toRadians(degrees) {
    var TAU = 2 * Math.PI;
    return degrees * TAU / 360;
}

function computeCircle(radius) {
    if (radius === 0) {
        radius = 2;
    }
    const positions = [];
    for (let i = 0; i < 360; i += 30) {
        const radians = toRadians(i);
        positions.push(
            new Cartesian2(
                radius * Math.cos(radians),
                radius * Math.sin(radians)
            )
        );
    }
    return positions;
}

function getConductorSize(value) {

    if (value == null) {
        var defaultConductorSize = 1000;
        return defaultConductorSize / 1500;
    }

    return value / 1500;
}

function getDiameter(value) {

    if (value == null) {
        var defaultConductorSize = 1000;
        return defaultConductorSize / 1000;
    }

    return value / 1000;
}

function getPipelineMaterialColor(value){
    let color = Color.RED;
    let materials = [
        {
            "material":"DI",//Ductile Iron
            "color":Color.fromCssColorString('#434B4D'),
        },
        {
            "material":"CI",//Cast Iron
            "color":Color.fromCssColorString('#434B4D'),
        },
        {
            "material":"PVC",//PVC
            "color":Color.GREY,
        },{
            "material":"AC",//Asbestos Concrete
            "color":Color.FUCHSIA,
        },{
            "material":"ST",//Steel
            "color":Color.GRAY,
        },{
            "material":"UNK",//Unknown
            "color":Color.GRAY,
        },{
            "material":"OTH",//Other
            "color":Color.GRAY,
        },{
            "material":"GS",//Galvanized Steel
            "color":Color.GRAY,
        },{
            "material":"HDPE",//High Density Poly Pipe
            "color":Color.fromCssColorString('#42AAFF'),
        },{
            "material":"MDPE",//Medium Density Poly Pipe
            "color":Color.GRAY,
        },{
            "material":"UPVC",//UPVC
            "color":Color.GRAY,
        },{
            "material":"MS",//Mild Steel
            "color":Color.GRAY,
        },{
            "material":"CS",//Carbon Steel
            "color":Color.BLUEVIOLET,
        },{
            "material":"PCC",//Plain Cement Concrete
            "color":Color.GRAY,
        },{
            "material":"CE",//Concrete Encasement
            "color":Color.GRAY,
        }
    ]
    let material = materials.find((e) => e.material == value);
    if(material !=null){
        color = material.color;
    }
    return color;
}

function getMarkerMaterialColor(value){
    let color = Color.RED;
    let materials = [
        {
            "material":"1",//Cement
            "color":Color.GRAY,
        },{
            "material":"2",//Steel
            "color":Color.GRAY,
        }
    ]
    let material = materials.find((e) => e.material == value);
    if(material !=null){
        color = material.color;
    }
    return color;
}

function getFrameMaterialColor(value){
    let color = Color.RED;
    let materials = [
        {
            "material":"STL",
            "color":Color.GRAY,
        },
        {
            "material":"IRON",
            "color":Color.fromCssColorString('#434B4D'),
        },
        {
            "material":"CMNT",
            "color":Color.GRAY,
        },{
            "material":"OTH",
            "color":Color.GRAY,
        },{
            "material":"UNK",
            "color":Color.GRAY,
        }
    ]
    let material = materials.find((e) => e.material == value);
    if(material !=null){
        color = material.color;
    }
    return color;
}

function getCoverMaterialColor(value){
    let color = Color.RED;
    let materials = [
        {
            "material":"STL",
            "color":Color.GRAY,
        },
        {
            "material":"IRON",
            "color":Color.fromCssColorString('#434B4D'),
        },
        {
            "material":"CMNT",
            "color":Color.GRAY,
        },{
            "material":"OTH",
            "color":Color.GRAY,
        },{
            "material":"UNK",
            "color":Color.GRAY,
        }
    ]
    let material = materials.find((e) => e.material == value);
    if(material !=null){
        color = material.color;
    }
    return color;
}

function getConductorMaterialColor(value){
    let color = Color.RED;
    let materials = [
        {
            "material":"0",//Aluminum
            "color":Color.SILVER,
        },
        {
            "material":"1",//Copper
            "color":Color.fromCssColorString('#b87333'),
        },
        {
            "material":"2",//ACSR
            "color":Color.SILVER,
        },
        {
            "material":"3",//Steel
            "color":Color.GREY,
        },
        {
            "material":"4",//Others
            "color":Color.BLUE,
        }
    ]
    let material = materials.find((e) => e.material === value);
    if(material !=null){
        color = material.color;
    }
    return color;
}


function getBuildingParams(num){
    let buildings = [
        {
            "num":"z_1",
            "node":'\u0417\u0434\u0430\u043d\u0438\u0435 1 (3)',
            "model":"models/buildings/building1.glb",
            "model_x":749985,
            "model_y":2503068,
            "model_z":6.72
        },{
            "num":"z_2",
            "node":'\u0417\u0434\u0430\u043d\u0438\u0435 2 (2)',
            "model":"models/buildings/building2.glb",
            "model_y":26.3,
            "model_x":12.2,
            // "model_x":23.9,
            // "model_y":26.9,
            "model_z":5.65
        },{
            "num":"z_3",
            "node":'\u0417\u0434\u0430\u043d\u0438\u0435 3 (2)',
            "model":"models/buildings/building3.glb",
            "model_x":14.2052,
            "model_y":10.2862,
            "model_z":5.65
        },{
            "num":"b_1",
            "node":'\u0431\u0430\u0448\u043d\u044f',
            "model":"models/buildings/tower.glb",
            "model_x":4.54,
            "model_y":4.54,
            "model_z":9.4
        }
    ]
    return buildings.find((e) => e.num == num);
}

export const _terrain ={
    id:0,
    name: Terrain,
    label: 'Terrain providers',
    elements:[
        {
            id: 1,
            name: "d1_area_dem",
            label: "D1 Area DEM",
            visible: true,
            init: async () => await CesiumTerrainProvider.fromUrl(applicationUrl+'/terrain/CMR_4326') //https://app.csds.om/madayn
        },
        {
            id: 2,
            name: "d1_area_dtm",
            label: "D1 Area DTM",
            visible: false,
            init: async () => await CesiumTerrainProvider.fromUrl(applicationUrl+'/terrain/DTM_4326')
        }
    ]
}

export const _layers = [
    {
        id: 1010,
        name: 'sur-3d',
        label: 'Sur (3D)',
        visible: false,
        type: Tileset,
        options: {
            data: applicationUrl + "/sur-mesh/tileset.json",
            cullWithChildrenBounds: false,
            maximumScreenSpaceError: 100
        }
    },
    {
        id: 1000,
        name: 'B1 Texture mesh',
        label: 'B1 3D-model',
        visible: false,
        type: Tileset,
        options: {
            data: applicationUrl+"/b1-texture/tileset.json"
        }
    },
    {
        id: 1001,
        name: 'D1 Mesh',
        label: 'D1 3D-model',
        visible: false,
        type: Tileset,
        options: {
            cullWithChildrenBounds: false,
            data: applicationUrl+"/d1-mesh/tileset.json"
        }
    },
    {
        id: 1003,
        name: 'D1 Mesh V2',
        label: 'D1 3D-model Version 2',
        visible: false,
        type: Tileset,
        options: {
            data: applicationUrl+"/d1-mesh-v2/tileset.json"
        }
    },
    {
        id: 1002,
        name: 'Area D1 TMS',
        label: 'area_d1_tms',
        visible: false,
        type: TMS,
        options: {
            data: applicationUrl+'/tms/D1_Ortho',
            fileExtension: 'png',
        }
    },
    // {
    //     id: 1002,
    //     name: 'Wms OSM',
    //     label: 'Wms OSM',
    //     visible: false,
    //     type: WMS,
    //     options: {
    //         url: 'https://maps2.geosolutionsgroup.com/geoserver/osm/wms',
    //         layers: 'osm_marine_dark1',
    //     }
    // },
    // {
    //     id: 1003,
    //     name: 'Arcgis test',
    //     label: 'Arcgis test',
    //     visible: false,
    //     type: ArcgisMapserver,
    //     options: {
    //         data: arcgisBaseURL + '/arcgis/rest/services/test/AreaD1_DEM_3857/MapServer',
    //         layers: '0',
    //     }
    // },
    // {
    //     id: 1004,
    //     name: 'nsdig2gapps.ncsi.gov.om',
    //     visible: false,
    //     type: ArcgisMapserver,
    //     options: {
    //         data : 'https://nsdig2gapps.ncsi.gov.om/arcgis/rest/services/NationalBaseMapEnDy/MapServer',
    //         layers : '-1,-1,-1,40,41,42,43,44,45,46',
    //     }
    // },
    {
        id: 300,
        label: 'OH-Stereo',
        name: 'OH_Stereo',
        visible: false,
    },
    {
        id: 301,
        parentId: 300,
        label: 'Poles - Type 1',
        name: 'poles_type1',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/poles_p.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 10230;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                
                    entity.model = { 
                        uri: 'models/electricity_pole_p.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 302,
        parentId: 300,
        label: 'Poles - type 2',
        name: 'poles_type2',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/poles_t.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 10250;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/electricity_pole_t.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 305,
        parentId: 300,
        label: 'Cables',
        name: 'cables_tp',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/el_lines_type_tp.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getConductorSize(10)),
                        material: Color.RED
                    });
                    entity.polyline.material = Color.fromCssColorString('#585b6a');
                    entity.polylineVolume.material = Color.fromCssColorString('#585b6a');
                }
            },
            stroke: Color.HOTPINK,
            fill: Color.PINK.withAlpha(0.5),
            strokeWidth: 3,
            //clampToGround: true
        }
    },
    {
        id: 306,
        parentId: 300,
        label: 'Poles - type 3',
        name: 'poles_type3',
        visible: false,
        collapsed: true
    },
    {
        id: 307,
        parentId: 306,
        label: 'Poles - type 3(bottom)',
        name: 'poles_type3_bot',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/farms_bot.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 34;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/farm_bot.glb',
                        //scale: (entity.properties.Height?.getValue()/model_height),
                    };

                    var scale_z = entity.properties.Height?.getValue()/model_height;
                    if (!defined(entity.model.nodeTransformations)) {
                        entity.model.nodeTransformations = new PropertyBag({});
                    }
                    entity.model.nodeTransformations.addProperty(
                        '\u041e\u043f\u043e\u0440\u0430\u041b\u042d\u041f_v2_\u043d\u0438\u0437',
                        new TranslationRotationScale(Cartesian3.ZERO, Quaternion.IDENTITY, new Cartesian3(1, scale_z, 1))
                    );

                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 308,
        parentId: 306,
        label: 'Poles - type 3(top)',
        name: 'poles_type3_top',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/farms_top.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 22.6;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/farm_top.glb',
                        //scale: (entity.properties.Height?.getValue()/model_height),
                    };

                    var scale_z = entity.properties.Height?.getValue()/model_height;
                    if (!defined(entity.model.nodeTransformations)) {
                        entity.model.nodeTransformations = new PropertyBag({});
                    }
                    entity.model.nodeTransformations.addProperty(
                        '\u0421\u0431\u043e\u0440\u043a\u0430 \u041b\u042d\u041f \u0432\u0435\u0440\u0445',
                        new TranslationRotationScale(Cartesian3.ZERO, Quaternion.IDENTITY, new Cartesian3(0.67, scale_z, 0.67))
                    );

                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    // {
    //     id: 309,
    //     label: 'Cables Farm',
    //     name: 'cables_farm',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: "./data/el_lines_type_farm.geojson",
    //         onLoad: (dataSource) => {
    //             //Get the array of entities
    //             var entities = dataSource.entities.values;
    //             for (var i = 0; i < entities.length; i++) {
    //                 //Set the height and the material of each polyline

    //                 var entity = entities[i];
    //                 entity.polylineVolume = new PolylineVolumeGraphics({
    //                     positions: entity.polyline.positions,
    //                     shape: computeCircle(getConductorSize(16)),
    //                     material: Color.RED
    //                 });
    //                 entity.polyline.material = Color.DARKVIOLET;
    //                 entity.polylineVolume.material = Color.DARKVIOLET;
    //             }
    //         },
    //         stroke: Color.HOTPINK,
    //         fill: Color.PINK.withAlpha(0.5),
    //         strokeWidth: 3,
    //         //clampToGround: true
    //     }
    // },
    {
        id: 310,
        parentId: 300,
        label: 'Street lights - type 1',
        name: 'street_lights_type1',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/street_lights_g.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 9510;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/street_light_g.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 311,
        parentId: 300,
        label: 'Street lights - type 2',
        name: 'street_lights_type2',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/street_lights_t.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 10250;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/street_light_t.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 312,
        parentId: 300,
        label: 'Street lights - type 3',
        name: 'street_lights_type3',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/street_lights_tt.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 10250;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/street_light_tt.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 313,
        parentId: 300,
        label: 'Transformers',
        name: 'transformers',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/transformers.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 2134;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/transformer.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 400,
        label: 'Fencing',
        name: 'fencing',
        visible: false,
    },
    {
        id: 401,
        parentId: 400,
        label: 'Metal Supports',
        name: 'metal_supports',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/fencing_metal_support.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 2218;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                
                    entity.model = { 
                        uri: 'models/fencing_metal_support.glb',
                        scale: (entity.properties.Height?.getValue()/model_height),
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 402,
        parentId: 400,
        label: 'Metal Grid',
        name: 'metal_grid',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/fencing_metal_grid.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height_max = 1770;
                const model_height_min = 40.10177993774414;
                let model_height = model_height_max-model_height_min;

                const model_x_max = 3000;
                const model_x_min = 0;
                let model_x = model_x_max - model_x_min;

                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/fencing_metal_grid.glb',
                        //scale: (entity.properties.Height?.getValue()/model_height),
                    };

                    var scale_z = entity.properties.Height?.getValue()/model_height;
                    var scale_x = entity.properties.Length?.getValue()/model_x;

                    if (!defined(entity.model.nodeTransformations)) {
                        entity.model.nodeTransformations = new PropertyBag({});
                    }
                    entity.model.nodeTransformations.addProperty(
                        '\u0417\u0430\u0431\u043e\u0440_\u043c\u0435\u0442\u0430\u043b_\u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u0435',
                        new TranslationRotationScale(Cartesian3.ZERO, Quaternion.IDENTITY, new Cartesian3(scale_x, scale_z, scale_z))
                    );

                    
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 403,
        parentId: 400,
        label: 'Concrete Supports',
        name: 'concrete_supports',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/fencing_concrete_support.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 2200;
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                
                    entity.model = { 
                        uri: 'models/fencing_concrete_support.glb',
                        scale: (entity.properties.Height?.getValue()/model_height)*1000,
                    };
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 404,
        parentId: 400,
        label: 'Concrete Slab',
        name: 'concrete_slab',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/fencing_concrete_slab.geojson",
            onLoad: (dataSource) => {
                //Get the array of entities
                const model_height = 2130;
                const model_x_max = 3790;
                const model_x_min = 189.99993896484375;
                let model_x = model_x_max - model_x_min;

                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;

                    entity.model = { 
                        uri: 'models/fencing_concrete_slab.glb',
                        //scale: (entity.properties.Height?.getValue()/model_height),
                    };

                    var scale_z = (entity.properties.Height?.getValue()/model_height)*1000;
                    var scale_x = (entity.properties.Length?.getValue()/model_x)*1000;

                    if (!defined(entity.model.nodeTransformations)) {
                        entity.model.nodeTransformations = new PropertyBag({});
                    }
                    entity.model.nodeTransformations.addProperty(
                        '\u0417\u0430\u0431\u043e\u0440_\u0431\u0435\u0442\u043e\u043d_\u043f\u043b\u0438\u0442\u0430 (2)',
                        new TranslationRotationScale(Cartesian3.ZERO, Quaternion.IDENTITY, new Cartesian3(scale_x, scale_z, scale_z))
                    );

                    
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue()+1);
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 500,
        label: 'Buildings',
        name: 'buildings',
        visible: false,
    },
    {
        id: 501,
        parentId: 500,
        label: 'Buildings',
        name: 'buildings',
        visible: false,
        type: GeoJSON,
        options: {
            data: "./data/buildings.geojson",
            onLoad: (dataSource) => {

                
                //Get the array of entities
                // const model_height_max = 8.670000076293945;
                // const model_height_min = 0;
                // let model_height = model_height_max-model_height_min;

                // const model_x = 749985;
                // const model_y = 2503068;

                // const object_x = 14.65;
                // const object_y = 27.3;
                
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    let params = getBuildingParams(entity.properties.Num.getValue());
                    entity.billboard = null;

                    entity.model = { 
                        uri: params.model,
                        //scale: (entity.properties.Height?.getValue()/model_height),
                    };

                    
                    var scale_x = (entity.properties.Side1?.getValue()/params.model_x);
                    var scale_z = (entity.properties.Height?.getValue()/params.model_z);
                    var scale_y = (entity.properties.Side2?.getValue()/params.model_y);

                    if(params.num === 'z_1'){
                        scale_x = scale_z;
                        scale_y = scale_z;
                    }
                    //scale_z = scale_z *1.26

                    if (!defined(entity.model.nodeTransformations)) {
                        entity.model.nodeTransformations = new PropertyBag({});
                    }
                    entity.model.nodeTransformations.addProperty(
                        params.node,
                        new TranslationRotationScale(Cartesian3.ZERO, Quaternion.IDENTITY, new Cartesian3(scale_x, scale_z, scale_y))
                    );

                    
                    const deltaRadians = CesiumMath.toRadians(entity.properties.RotationAngle?.getValue());
                    const hpRoll = new HeadingPitchRoll();
                    
                    hpRoll.heading = deltaRadians;
                    entity.orientation = Transforms.headingPitchRollQuaternion(entity.position.getValue(JulianDate.now()), hpRoll);
                }
            }
        }
    },
    {
        id: 2,
        label: 'Electricity',
        name: 'Electricity',
        visible: false,
    },
    {
        id: 270,
        parentId: 2,
        label: 'Transformers',
        name: 'ELE_Transformer',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/70/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.box = {
                        dimensions: new Cartesian3(5, 5, 7),
                        material: Color.RED,
                        outline: true,
                        outlineColor: Color.BLACK,
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 271,
        parentId: 2,
        label: 'Substations',
        name: 'ELE_Substation',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/71/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.fromCssColorString('#005700'),
            stroke: Color.BLACK
        }
    },
    {
        id: 3,
        parentId: 2,
        label: 'Poles',
        name: 'ELE_Pole',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/SurB_Electrical_v4/FeatureServer/1/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: entity.properties.Height?.getValue() || defaultPoleHeight,
                        topRadius: 0.5,
                        bottomRadius: 0.5,
                        material: Color.BLUE,
                        //heightReference: HeightReference.CLAMP_TO_3D_TILE
                    };

                    const llh = entity.position.getValue(JulianDate.now());
                    const cartographic = Cartographic.fromCartesian(llh);
                    var new_carto = new Cartographic(cartographic.longitude,
                        cartographic.latitude,
                        cartographic.height - (entity.properties.Height?.getValue() || cartographic.height - defaultPoleHeight) / 2
                    );
                    var new_catesian3 = Cartesian3.fromRadians(new_carto.longitude, new_carto.latitude, new_carto.height);

                    entity.position.setValue(new_catesian3);

                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 4,
        parentId: 2,
        label: 'Meters',
        name: 'ELE_Meter',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/73/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.model = { uri: 'models/electricity_meter_1_fb0000.glb' };
                    // entity.box = {
                    //     dimensions: new Cartesian3(3, 3, 3),
                    //     material: Color.RED,
                    //     outline: true,
                    //     outlineColor: Color.BLACK,
                    // };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 5,
        parentId: 2,
        label: 'HVUG electric lines',
        name: 'ELE_HVUGElectricLine',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/74/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getConductorSize(entity.properties.ConductorSize.getValue())),
                        material: getConductorMaterialColor(entity.properties.ConductorMaterial.getValue())
                    });
                    entity.polyline.material = Color.DARKVIOLET;
                }
            },
            stroke: Color.HOTPINK,
            fill: Color.PINK.withAlpha(0.5),
            strokeWidth: 3,
            //clampToGround: true
        }
    },
    {
        id: 6,
        parentId: 2,
        label: 'LVUG electric lines',
        name: 'ELE_LVUGElectricLine',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/75/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    if (entity.polyline == null) {
                        continue;
                    }
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getConductorSize(entity.properties.ConductorSize.getValue())),
                        material: getConductorMaterialColor(entity.properties.ConductorMaterial.getValue())
                    });
                    entity.polyline.material = Color.YELLOW;
                }
            },
            stroke: Color.RED,
            fill: Color.PINK.withAlpha(0.5),
            strokeWidth: 3,
            //clampToGround: true
        }
    },
    {
        id: 7,
        parentId: 2,
        label: 'HVOH electric lines',
        name: 'ELE_HVOHElectricLine',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/SurB_Electrical_v4/FeatureServer/0/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getConductorSize(entity.properties.ConductorSize.getValue())),
                        material: Color.RED
                    });
                    entity.polyline.material = Color.DARKVIOLET;
                    entity.polylineVolume.material = Color.DARKVIOLET;
                }
            },
            stroke: Color.HOTPINK,
            fill: Color.PINK.withAlpha(0.5),
            strokeWidth: 3,
            //clampToGround: true
        }
    },
    {
        id: 8,
        parentId: 2,
        label: 'LVOH electric lines',
        name: 'ELE_LVOHElectricLine',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/77/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getConductorSize(entity.properties.ConductorSize.getValue())),
                        material: getConductorMaterialColor(entity.properties.ConductorMaterial.getValue())
                    });
                    entity.polyline.material = Color.GREEN;
                }
            },
            stroke: Color.RED,
            fill: Color.PINK.withAlpha(0.5),
            strokeWidth: 3,
            //clampToGround: true
        }
    },
    {
        id: 9,
        parentId: 2,
        label: 'Cable markers',
        name: 'ELE_CableMarker',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/78/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            markerColor: Color.fromCssColorString('#88001b'),
            markerSize: 20
        }
    },
    {
        id: 10,
        parentId: 2,
        label: 'Duct edges',
        name: 'ELE_DuctEdge',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/79/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.GREEN,
            stroke: Color.BLACK
        }
    },
    {
        id: 11,
        parentId: 2,
        label: 'Feeder pillars',
        name: 'ELE_FeederPillar',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/80/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.GREEN,
            stroke: Color.BLACK
        }
    },
    {
        id: 12,
        parentId: 2,
        label: 'Earth pits',
        name: 'ELE_EarthPit',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/81/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            markerColor: Color.fromCssColorString('#ff375a'),
            markerSize: 20
        }
    },
    {
        id: 13,
        parentId: 2,
        label: 'Manholes',
        name: 'ELE_Manhole',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/82/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.polygon.material = getCoverMaterialColor(entity.properties.CoverMaterial.getValue());
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                }
            },

        }
    },
    {
        id: 14,
        label: 'Water',
        name: 'Water',
        visible: false,
    },
    {
        id: 15,
        parentId: 14,
        label: 'Chambers',
        name: 'PW_Chamber',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/0/query?where=OBJECTID%20NOT%20IN(43,44,45,46,47,528,531,534)&f=geojson&returnGeometry=true&returnZ=false&outFields=*",
            // stroke: Color.BLACK,
            // clampToGround: true,
            onLoad: (dataSource) => {
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.material = getCoverMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.heightReference = HeightReference.CLAMP_TO_3D_TILE;
                }
            },

        }
    },
    {
        id: 16,
        parentId: 14,
        label: 'Duct edges',
        name: 'PW_DuctEdge',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/1/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.fromCssColorString('#008c27'),
            stroke: Color.BLACK
        }
    },
    {
        id: 17,
        parentId: 14,
        label: 'Hydrant safety barriers',
        name: 'PW_HydrantSafetyBarrier',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/2/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.GOLDENROD,
            stroke: Color.BLACK
        }
    },
    {
        id: 18,
        parentId: 14,
        label: 'Fire hydrants',
        name: 'PW_FireHydrant',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/3/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0,
                        bottomRadius: 0.3,
                        material: Color.RED,
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 19,
        parentId: 14,
        label: 'Mains',
        name: 'PW_Mains',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/4/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++){
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    let color = getPipelineMaterialColor(entity.properties.Material.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getDiameter(entity.properties.Diameter.getValue())),
                        material: color
                    });
                    entity.polyline.material = color;
                    entity.polylineVolume.material = color;    
                }
            },
            // stroke: Color.HOTPINK,
            // fill: Color.BLACK.withAlpha(0.5),
            // strokeWidth: 2,
            //clampToGround: true
        }
    },
    {
        id: 20,
        parentId: 14,
        label: 'Meters',
        name: 'PW_Meter',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/6/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0,
                        bottomRadius: 0.3,
                        material: Color.BLACK,
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 21,
        parentId: 14,
        label: 'Facilities',
        name: 'PW_Facilities',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/7/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.BLUE,
            stroke: Color.BLACK
        }
    },
    {
        id: 22,
        parentId: 14,
        label: 'Pipeline markers',
        name: 'PW_PipelineMarker',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/9/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0,
                        bottomRadius: 0.3,
                        material: getMarkerMaterialColor(entity.properties.Material.getValue()),
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 23,
        parentId: 14,
        label: 'Endcaps',
        name: 'PW_Endcap',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/10/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0,
                        bottomRadius: 0.3,
                        material: getPipelineMaterialColor(entity.properties.Material.getValue()),
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 24,
        label: 'Telecom',
        name: 'Telecom',
        visible: false,
    },
    {
        id: 25,
        parentId: 24,
        label: 'Duct edges',
        name: 'TEL_DuctEdge',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/11/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.fromCssColorString('#ffc400'),
            strokeWidth: 1,
            // onLoad: (dataSource) => {
            //     //Get the array of entities
            //     var entities = dataSource.entities.values;
            //     for (var i = 0; i < entities.length; i++) {
            //         //Set the height and the material of each polyline

            //         var entity = entities[i];
            //         entity.billboard = null;
            //         entity.cylinder = {
            //             length: 3,
            //             topRadius: 0,
            //             bottomRadius: 0.3,
            //             material: Color.ROSYBROWN,
            //             //heightReference: HeightReference.CLAMP_TO_GROUND
            //         };
            //         //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
            //         // console.log(entity.polyline.positions);

            //         //viewer.zoomTo(entities);
            //     }
            // }
        }
    },
    {
        id: 26,
        parentId: 24,
        label: 'Fibers',
        name: 'TEL_Fiber',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/12/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            // onLoad: (dataSource) => {
            //     //Get the array of entities
            //     var entities = dataSource.entities.values;
            //     for (var i = 0; i < entities.length; i++){
            //         //Set the height and the material of each polyline

            //         var entity = entities[i];
            //         // console.log(entity.polyline.positions);
            //         //console.log(entity.properties.ConductorSize.getValue());
            //         entity.polylineVolume = new PolylineVolumeGraphics({
            //             positions: entity.polyline.positions,
            //             shape:computeCircle(entity.properties.ConductorSize.getValue()/100),
            //             material: Color.RED
            //         });
            //         entity.polyline.material = Color.DARKVIOLET;
            //         entity.polylineVolume.material = Color.DARKVIOLET;    
            //     }
            // },
            stroke: Color.ROSYBROWN,
            fill: Color.BLACK.withAlpha(0.5),
            strokeWidth: 2,
            //clampToGround: true
        }
    },
    {
        id: 27,
        parentId: 24,
        label: 'Plots',
        name: 'TEL_Plots',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/14/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.ROSYBROWN,
            stroke: Color.BLACK
        }
    },
    {
        id: 28,
        parentId: 24,
        label: 'Towers',
        name: 'TEL_Tower',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/15/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: entity.properties.Height?.getValue() || defaultPoleHeight,
                        topRadius: 0.3,
                        bottomRadius: 0.3,
                        material: Color.ROSYBROWN,
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 29,
        parentId: 24,
        label: 'Telephone boxes',
        name: 'TEL_TelephoneBox',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/17/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.box = {
                        dimensions: new Cartesian3(1, 1, 2),
                        material: Color.fromCssColorString('#612828'),
                        outline: true,
                        outlineColor: Color.BLACK,
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 30,
        parentId: 24,
        label: 'Chambers',
        name: 'TEL_Chamber',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/18/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.material = getCoverMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.heightReference = HeightReference.CLAMP_TO_3D_TILE;
                }
            },

        }
    },
    {
        id: 31,
        label: 'Sewerage',
        name: 'Sewerage',
        visible: false,
    },
    {
        id: 32,
        parentId: 31,
        label: 'Chambers',
        name: 'SW_Chamber',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/20/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.material = getCoverMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.heightReference = HeightReference.CLAMP_TO_3D_TILE;
                }
            },

        }
    },
    {
        id: 33,
        parentId: 31,
        label: 'Force mains',
        name: 'SW_ForceMains',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/21/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++){
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape:computeCircle(0.3),
                        material: Color.RED
                    });
                    entity.polyline.material = Color.RED;
                    entity.polylineVolume.material = Color.RED;    
                }
            },
            // stroke: Color.BROWN,
            // fill: Color.BLACK.withAlpha(0.5),
            // strokeWidth: 2,
            //clampToGround: true
        }
    },
    {
        id: 34,
        parentId: 31,
        label: 'Duct edges',
        name: 'SW_DuctEdge',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/22/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.BROWN,
            stroke: Color.BLACK
        }
    },
    {
        id: 35,
        parentId: 31,
        label: 'Manholes',
        name: 'SW_Manhole',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/24/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    var entity = entities[i];
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.material = getCoverMaterialColor(entity.properties.FrameMaterial.getValue());
                    entity.polygon.heightReference = HeightReference.CLAMP_TO_3D_TILE;
                }
            },

        }
    },
    {
        id: 91,
        parentId: 31,
        label: 'Drainge systems',
        name: 'DraingeSystem',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/26/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(0.2),
                        material: Color.BROWN
                    });
                    entity.polyline.material = Color.BROWN;
                    entity.polylineVolume.material = Color.BROWN;
                }
            },
            stroke: Color.BROWN,
            fill: Color.BLACK.withAlpha(0.5),
            strokeWidth: 2,
            //clampToGround: true
        }
    },
    {
        id: 36,
        label: 'Irrigation',
        name: 'Irrigation',
        visible: false,
    },
    {
        id: 37,
        parentId: 36,
        label: 'Chambers',
        name: 'IRR_Chamber',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/42/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            // fill: Color.BLUE,
            // stroke: Color.BLUEVIOLET,
            strokeWidth: 2,
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.polygon.material = getCoverMaterialColor(entity.properties.CoverMaterial.getValue());
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                }
            },

        }
    },
    {
        id: 38,
        parentId: 36,
        label: 'Pipe lines',
        name: 'IRR_PipeLine',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/46/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getDiameter(entity.properties.Diameter.getValue())),
                        material: getPipelineMaterialColor(entity.properties.Material.getValue())

                    });
                    entity.polyline.material = Color.DARKVIOLET;
                }
            },
            stroke: Color.BLUEVIOLET,
            fill: Color.BLUE.withAlpha(0.5),
            strokeWidth: 2,
            //clampToGround: true
        }
    },
    {
        id: 39,
        parentId: 36,
        label: 'Pump stations',
        name: 'IRR_PumpStation',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/47/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.fromCssColorString('#0055ff'),
            stroke: Color.BLUEVIOLET,
            strokeWidth: 2
        }
    },
    {
        id: 40,
        label: 'Gas',
        name: 'Gas',
        visible: false,
    },
    {
        id: 41,
        parentId: 40,
        label: 'Pipeline markers',
        name: 'GAS_PipelineMarker',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/64/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0,
                        bottomRadius: 0.3,
                        material: getMarkerMaterialColor(entity.properties.Material.getValue()),
                        heightReference: HeightReference.CLAMP_TO_3D_TILE
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 42,
        parentId: 40,
        label: 'Duct edges',
        name: 'GAS_DuctEdge',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/65/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.fromCssColorString('#5ecfcf'),
            stroke: Color.fromCssColorString('#8a2be2'),
            strokeWidth: 2
        }
    },
    {
        id: 43,
        parentId: 40,
        label: 'Meters',
        name: 'GAS_Meter',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/66/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0,
                        bottomRadius: 0.3,
                        material: Color.LIGHTBLUE,
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 44,
        parentId: 40,
        label: 'Chambers',
        name: 'GAS_Chamber',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/67/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            // fill: Color.fromCssColorString('#6dffff'),
            // stroke: Color.fromCssColorString('#8a2be2'),
            strokeWidth: 2,
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.polygon.material = getCoverMaterialColor(entity.properties.CoverMaterial.getValue());
                    entity.polygon.outlineColor = getFrameMaterialColor(entity.properties.FrameMaterial.getValue());
                }
            },

        }
    },
    {
        id: 45,
        parentId: 40,
        label: 'Stations',
        name: 'GAS_Station',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/68/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.LIGHTBLUE,
            stroke: Color.BLUEVIOLET,
            strokeWidth: 2
        }
    },
    {
        id: 46,
        parentId: 40,
        label: 'Mains',
        name: 'GAS_Mains',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/69/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polylineVolume = new PolylineVolumeGraphics({
                        positions: entity.polyline.positions,
                        shape: computeCircle(getDiameter(entity.properties.Diameter.getValue())),
                        material: getPipelineMaterialColor(entity.properties.Material.getValue()),
                        outline: Color.BLACK
                    });
                    entity.polyline.material = Color.DARKVIOLET;
                }
            },
            stroke: Color.BLUEVIOLET,
            fill: Color.BLUE.withAlpha(0.5),
            strokeWidth: 2,
            //clampToGround: true
        }
    },
    {
        id: 47,
        label: 'Plots',
        name: 'Plots_Group',
        visible: false,
    },
    {
        id: 234,
        parentId: 47,
        label: 'Buildings',
        name: 'Buildings',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/34/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.fromCssColorString('#5b5555'),
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 233,
        parentId: 47,
        label: 'Estate',
        name: 'Estate',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/33/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.GRAY,
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 228,
        parentId: 47,
        label: 'Plots',
        name: 'Plots',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/28/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=false&outFields=*",
            stroke: Color.BLACK,
            fill: Color.TRANSPARENT,
            strokeWidth: 1,
            clampToGround:true,
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    // entity.polygon = {
                    //     hierarchy:entity.polygon.hierarchy.getValue(),
                    //     material:Color.LIGHTGREEN
                    //   };
                    entity.polyline = {
                        positions: entity.polygon.hierarchy.getValue().positions,
                        width: 3,
                        material: Color.LIGHTGREEN,
                        clampToGround: true
                        };
                }
            },
        }
    },
    {
        id: 95,
        label: 'Other',
        name: 'Other',
        visible: false,
    },
    {
        id: 235,
        parentId: 95,
        label: 'Contours',
        name: 'Contours',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/35/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 236,
        parentId: 95,
        label: 'Unknown features',
        name: 'UnknownFeatures',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/36/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 96,
        label: 'Infrastructure',
        name: 'Infrastructure',
        visible: false,
    },
    {
        id: 249,
        parentId: 96,
        label: 'Street lights',
        name: 'StreetLight',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/49/query?where=OBJECTID%20NOT%20IN(722,926,1078,1208,1209,1226,1359,1360,1445)&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0.3,
                        bottomRadius: 0.3,
                        material: Color.YELLOW,
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 250,
        parentId: 96,
        label: 'Roads roundabouts',
        name: 'RoadsRoundabout',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/50/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 251,
        parentId: 96,
        label: 'Roads centre lines',
        name: 'RoadsCentreLine',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/51/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 252,
        parentId: 96,
        label: 'Roads',
        name: 'Roads',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/52/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=false&outFields=*",
            stroke: Color.BLACK,
            fill: Color.GREY,
            strokeWidth: 1,
            clampToGround:true,
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.HeightReference = HeightReference.CLAMP_TO_TERRAIN;
                    // console.log(entity.polyline.positions);
                    //console.log(entity.properties.ConductorSize.getValue());
                    entity.polygon = {
                        hierarchy:entity.polygon.hierarchy.getValue(),
                        material:Color.GREY,
                        //HeightReference:HeightReference.CLAMP_TO_TERRAIN
                        };
                    entity.polyline = {
                        positions: entity.polygon.hierarchy.getValue().positions,
                        width: 1,
                        material: Color.BLACK,
                        //HeightReference : HeightReference.CLAMP_TO_TERRAIN
                        clampToGround: true
                        };
                }
            },
        }
    },
    {
        id: 253,
        parentId: 96,
        label: 'Parkings',
        name: 'Parking',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/53/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.YELLOW,
            strokeWidth: 4
        }
    },
    {
        id: 254,
        parentId: 96,
        label: 'Interlocks',
        name: 'Interlock',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/54/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.GREY,
            strokeWidth: 1
        }
    },
    {
        id: 255,
        parentId: 96,
        label: 'Gates',
        name: 'Gate',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/55/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 259,
        parentId: 96,
        label: 'CCTV',
        name: 'CCTV',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/59/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            markerColor: Color.RED,
            markerSize: 20
        }
    },
    {
        id: 261,
        parentId: 96,
        label: 'Fencings',
        name: 'Fencing',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/61/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.GREEN,
            strokeWidth: 4
        }
    },
    {
        id: 262,
        parentId: 96,
        label: 'Road signs',
        name: 'RoadSign',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/62/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.cylinder = {
                        length: 3,
                        topRadius: 0.3,
                        bottomRadius: 0.0,
                        material: Color.fromCssColorString('#006d8e'),
                        //heightReference: HeightReference.CLAMP_TO_GROUND
                    };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 51,
        label: 'Landscape',
        name: 'Landscape',
        visible: false,
    },
    {
        id: 52,
        parentId: 51,
        name: 'Carbstones',
        label: 'Carbstone',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/39/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.GREEN,
            strokeWidth: 2
        }
    },
    {
        id: 53,
        parentId: 51,
        name: 'Greens',
        label: 'Green',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/38/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            fill: Color.GREEN.withAlpha(0.3),
            stroke: Color.BLACK,
            strokeWidth: 1
        }
    },
    {
        id: 54,
        parentId: 51,
        name: 'Trees',
        label: 'Trees',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/37/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            onLoad: (dataSource) => {
                //Get the array of entities
                var entities = dataSource.entities.values;
                for (var i = 0; i < entities.length; i++) {
                    //Set the height and the material of each polyline

                    var entity = entities[i];
                    entity.billboard = null;
                    entity.model = { uri: 'models/tree_1.glb' };
                    // entity.cylinder = {
                    //     length: 10,
                    //     topRadius: 0.2,
                    //     bottomRadius: 0.2,
                    //     material: Color.GREEN.withAlpha(0.5),
                    //     //heightReference: HeightReference.CLAMP_TO_GROUND
                    // };
                    //entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_TERRAIN;
                    // console.log(entity.polyline.positions);

                    //viewer.zoomTo(entities);
                }
            }
        }
    },
    {
        id: 55,
        parentId: 51,
        name: 'Wadis',
        label: 'Wadi',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur1/"+arcgisMap+"/FeatureServer/41/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.GREEN.withAlpha(0.3),
            strokeWidth: 2
        }
    },
    {
        id: 56,
        label: 'Ministry of Housing',
        name: 'Ministry of Housing',
        visible: false,
    },
    // {
    //     id: 58,
        // parentId: 56,
    //     name: 'Enhancing Rural Communities Policy (Governorate_Specific)',
    //     label: 'Enhancing Rural Communities Policy (Governorate_Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/1/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.GREEN.withAlpha(0.3),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 59,
        // parentId: 56,
    //     name: 'Ensuring Adequate Land For Development Policy_Designation',
    //     label: 'Ensuring Adequate Land For Development Policy_Designation',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/2/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.TRANSPARENT,
    //         strokeWidth: 2
    //     }
    // },
    {
        id: 60,
        parentId: 56,
        name: 'Ensuring Adequate Land For Development Policy_Landuse',
        label: 'Ensuring adequate land development policy',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/3/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.TRANSPARENT,
            strokeWidth: 2
        }
    },
    // {
    //     id: 61,
        // parentId: 56,
    //     name: 'National Settlement Hierarchy Policy',
    //     label: 'National Settlement Hierarchy Policy',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/4/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.TRANSPARENT,
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 62,
        // parentId: 56,
    //     name: 'Providing Community Facilities Policy_Designation (Governorate_Specific)',
    //     label: 'Providing Community Facilities Policy_Designation (Governorate_Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/5/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BISQUE.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 63,
        // parentId: 56,
    //     name: 'Providing Community Facilities Policy_Landuse (Governorate_Specific)',
    //     label: 'Providing Community Facilities Policy_Landuse (Governorate_Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/6/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BISQUE.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 64,
        // parentId: 56,
    //     name: 'RSS_CE1 Coastal Zone Management Policy (Specific)',
    //     label: 'RSS_CE1 Coastal Zone Management Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/7/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BLUEVIOLET.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 65,
        // parentId: 56,
    //     name: 'RSS_CE2 Coastal_Special_Planning_Zones_Policy (Specific)',
    //     label: 'RSS_CE2 Coastal_Special_Planning_Zones_Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/8/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BLUEVIOLET.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 66,
        // parentId: 56,
    //     name: 'RSS_CE3 Marine Spatial Planning Policy (Specific)',
    //     label: 'RSS_CE3 Marine Spatial Planning Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/9/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BLUEVIOLET.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 67,
        // parentId: 56,
    //     name: 'RSS_CH1 Conservation Areas Policy (Specific)',
    //     label: 'RSS_CH1 Conservation Areas Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/10/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BURLYWOOD.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 68,
        // parentId: 56,
    //     name: 'RSS_CH2 World Heritage Sites Policy (Specific)',
    //     label: 'RSS_CH2 World Heritage Sites Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/11/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BURLYWOOD.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 69,
        // parentId: 56,
    //     name: 'RSS_CH3 Cultural Landscapes Policy (Specific)',
    //     label: 'RSS_CH3 Cultural Landscapes Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/12/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BURLYWOOD.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 70,
        // parentId: 56,
    //     name: 'RSS_CH3 Cultural Landscapes Policy_Designation (Specific)',
    //     label: 'RSS_CH3 Cultural Landscapes Policy_Designation (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/13/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BURLYWOOD.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 71,
        // parentId: 56,
    //     name: 'RSS_CH4 Historic Buildings Policy (Governorate+Specific)',
    //     label: 'RSS_CH4 Historic Buildings Policy (Governorate+Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/14/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BURLYWOOD.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 72,
        // parentId: 56,
    //     name: 'RSS_CH5 Cultural_Traditions_Policy (Specific)',
    //     label: 'RSS_CH5 Cultural_Traditions_Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/15/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.BURLYWOOD.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 73,
        // parentId: 56,
    //     name: 'RSS_GP1_Employment_Growth_Policy_Designation (Specific)',
    //     label: 'RSS_GP1_Employment_Growth_Policy_Designation (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/16/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.RED.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 74,
        // parentId: 56,
    //     name: 'RSS_GP1_Employment_Growth_Policy_Landuse (Specific)',
    //     label: 'RSS_GP1_Employment_Growth_Policy_Landuse (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/17/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.RED.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 75,
        // parentId: 56,
    //     name: 'RSS_GP2_Special_Economic_Designations_Policy (Specific)',
    //     label: 'RSS_GP1_Employment_Growth_Policy_Landuse (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/18/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.RED.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 76,
        // parentId: 56,
    //     name: 'RSS_GP3_Employment_Growth_Business_Clustering_Competitiveness_Policy',
    //     label: 'RSS_GP3_Employment_Growth_Business_Clustering_Competitiveness_Policy',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/19/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.RED.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 77,
        // parentId: 56,
    //     name: 'RSS_GP4_Employment_Growth_Business_Clustering_Finance_Policy',
    //     label: 'RSS_GP4_Employment_Growth_Business_Clustering_Finance_Policy',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/20/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.RED.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 78,
        // parentId: 56,
    //     name: 'RSS_SD9_Social_Cohesion_and_Maintaining_Omani_Identity_Policy (Governorate)',
    //     label: 'RSS_SD9_Social_Cohesion_and_Maintaining_Omani_Identity_Policy (Governorate)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/21/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.YELLOWGREEN.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 79,
        // parentId: 56,
    //     name: 'RSS_SD10_Controlling_Inappropriate_Development_Policy (Governorate)',
    //     label: 'RSS_SD10_Controlling_Inappropriate_Development_Policy (Governorate)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/22/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.YELLOWGREEN.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 80,
        // parentId: 56,
    //     name: 'RSS_SD11 Terrestrial Special Planning Zones Policy (Specific)',
    //     label: 'RSS_SD11 Terrestrial Special Planning Zones Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/23/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.YELLOWGREEN.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 81,
        // parentId: 56,
    //     name: 'RSS_SD12 Greening the Built Environment Policy (Governorate)',
    //     label: 'RSS_SD12 Greening the Built Environment Policy (Governorate)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/24/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.YELLOWGREEN.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 82,
        // parentId: 56,
    //     name: 'RSS_TE1 Conservation Biodiversity Geology and Landscape Policy (Specific)',
    //     label: 'RSS_TE1 Conservation Biodiversity Geology and Landscape Policy (Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/25/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.HONEYDEW.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 83,
        // parentId: 56,
    //     name: 'RSS_TE2_State_of_the_Environment_Policy (Governorate)',
    //     label: 'RSS_TE2_State_of_the_Environment_Policy (Governorate)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/26/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.HONEYDEW.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    {
        id: 84,
        parentId: 56,
        name: 'RSS_TE3_Improving_Air_Quality_and_Managing_Noise_Policy (Governorate)',
        label: 'Improving air quality and managing noise policy',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/27/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.HONEYDEW.withAlpha(0.1),
            strokeWidth: 2
        }
    },
    {
        id: 85,
        parentId: 56,
        name: 'Settlement Boundaries Policy',
        label: 'Settlement boundaries policy',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/28/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.THISTLE.withAlpha(0.1),
            strokeWidth: 2
        }
    },
    // {
    //     id: 86,
        // parentId: 56,
    //     name: 'Smart_and_Liveable_Cities_Policy (Governorate)',
    //     label: 'Smart_and_Liveable_Cities_Policy (Governorate)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/29/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.THISTLE.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 87,
        // parentId: 56,
    //     name: 'Transit Oriented Developments Policy(Specific)',
    //     label: 'Transit Oriented Developments Policy(Specific)',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/30/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.THISTLE.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    // {
    //     id: 88,
        // parentId: 56,
    //     name: 'Urban Transformation Policy_Designation',
    //     label: 'Urban Transformation Policy_Designation',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/31/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.THISTLE.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
    {
        id: 89,
        parentId: 56,
        name: 'Urban Transformation Policy_Landuse',
        label: 'Urban transformation policy',
        visible: false,
        type: GeoJSON,
        options: {
            data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/32/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
            stroke: Color.BLACK,
            fill: Color.THISTLE.withAlpha(0.1),
            strokeWidth: 2
        }
    },
    // {
    //     id: 90,
        // parentId: 56,
    //     name: 'Urban Transformation_Windfall Sites',
    //     label: 'Urban Transformation_Windfall Sites',
    //     visible: false,
    //     type: GeoJSON,
    //     options: {
    //         data: arcgisBaseURL + "/arcgis/rest/services/Sur/ministry_housing/FeatureServer/33/query?where=1%3D1&f=geojson&returnGeometry=true&returnZ=true&outFields=*",
    //         stroke: Color.BLACK,
    //         fill: Color.THISTLE.withAlpha(0.1),
    //         strokeWidth: 2
    //     }
    // },
];